import React from 'react';
import { X, Coins } from 'lucide-react';

const DailyBonusModal = ({ streakData, onCollect, onClose }) => {
  const { streak, bonusCoins, streakBroken } = streakData;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-sm w-full mx-4 relative animate-bounce-in shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          {streakBroken ? (
            <>
              <div className="text-6xl mb-4">😢</div>
              <h2 className="text-xl font-bold text-gray-800 mb-2">
                Oh no! Your streak was broken
              </h2>
              <p className="text-gray-600 mb-4">
                But don't worry - let's start a new one!
              </p>
            </>
          ) : (
            <>
              <div className="text-6xl mb-4">🔥</div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                {streak} Day Streak!
              </h2>
              <p className="text-gray-600 mb-4">
                {streak === 1
                  ? "You've started a new streak!"
                  : 'Keep up the amazing work!'}
              </p>
            </>
          )}

          <div className="bg-gradient-to-r from-yellow-100 to-amber-100 rounded-xl p-4 mb-6 border border-yellow-200">
            <div className="flex items-center justify-center gap-2">
              <Coins className="w-8 h-8 text-yellow-600" />
              <span className="text-3xl font-bold text-yellow-700">
                +{bonusCoins}
              </span>
            </div>
            <p className="text-sm text-yellow-600 mt-1">Daily Bonus Coins</p>
          </div>

          <button
            onClick={onCollect}
            className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white py-3 rounded-xl font-bold text-lg hover:from-teal-600 hover:to-emerald-600 transition-all transform hover:scale-105 shadow-lg"
          >
            Collect Bonus!
          </button>

          {streak >= 7 && !streakBroken && (
            <p className="text-xs text-purple-600 mt-4 font-medium">
              🎉 Weekly milestone reached! You're on fire!
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyBonusModal;
